<!-- 路由过渡页面 -->
<template>
	<div class="back">
	</div>
</template>
<script>
export default {
  data () {
    return {
    }
  },
  created () {
    // 获取当前的路由
    let path = this.$route.params.link
    //替换为原先路由
    this.$router.replace({
      path: path,
      query: {}
    })
  }
}
</script>
